import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sgjd",
  "use": "icon-sgjd-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-sgjd\">\n<g>\n\t<g>\n\t\t<rect y=\"1.083\" width=\"2.042\" height=\"13.979\" />\n\t\t<rect y=\"14.021\" width=\"15.063\" height=\"2.043\" />\n\t</g>\n\t<polyline stroke-width=\"2\" stroke-miterlimit=\"10\" points=\"3.708,3.417 6.146,9.5 9.938,5.729 \n\t\t14.563,12.063 \t\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol